import { TFTSMonthlyState } from './types';

export function setTableData(state: TFTSMonthlyState, data: TFTSMonthlyState['tableData']) {
  state.tableData = data;
}
